export default {
  props: {
    itemData: {
      type: Object,
      default: () => {}
    }
  },
  computed: {},
  data() {
    return {};
  },
  mounted() {},
  computed: {},
  methods: {}
};